import React from "react";
import { useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import GeneralSettingsBasic from "./GeneralSettingsBasic";
import StoreLocation from "./StoreLocation";
import ApiKey from "./ApiKey";
import AddUser from "./AddUser";
import PaymentGateway from "../PaymentGateway/PaymentGateway";
import LoadingScreen from "../../../../Shared/LoadingScreen";
import { PrimaryButton } from "../../../../Shared/Buttons";
import PosApiEndpointsListComp from "./PosApiEndpointsListComp";
import RestMenuComp from "../GeneralSettings/menu";

const GeneralSettings = ({
  classes,
  settings,
  setSettings,
  loading,
  handleSubmit,
  isValid,
  setIsValid,
  fetchSettings,
  handleSnackbarOpen,
}) => {
  return (
    <>
      {loading ? (
        <LoadingScreen loading={loading} />
      ) : (
        <>
          <Grid container direction="row">
            <GeneralSettingsBasic
              classes={classes}
              settings={settings}
              setSettings={setSettings}
              handleSnackbarOpen={handleSnackbarOpen}
            />
            <StoreLocation
              classes={classes}
              settings={settings}
              setSettings={setSettings}
              isValid={isValid}
              setIsValid={setIsValid}
            />
            <RestMenuComp
              handleSnackbarOpen={handleSnackbarOpen}
              classes={classes}
            />
            <AddUser
              classes={classes}
              settings={settings}
              setSettings={setSettings}
            />
            <ApiKey
              classes={classes}
              settings={settings}
              setSettings={setSettings}
            />
            {/* <PosApiEndpointsListComp
              classes={classes}
            /> */}
            <PaymentGateway
              classes={classes}
              settings={settings}
              setSettings={setSettings}
            />
          </Grid>
          <Grid
            container
            direction="row"
            spacing={1}
            justify="center"
            className={classes.mt20}
          >
            <Grid item xs={4} sm={2}>
              <PrimaryButton
                type="success"
                fullWidth={true}
                handleClick={handleSubmit}
                testId="save_rest_detail_btn"
              >
                Save
              </PrimaryButton>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default GeneralSettings;
